import type { JSX } from 'react';
import { Box, Loader } from '@ksyos/design-system';

export function OutclinicDashboardLoader(): JSX.Element {
    return (
        <Box
            alignItems="center"
            bottom="0"
            display="flex"
            justifyContent="center"
            left="0"
            position="fixed"
            right="0"
            sx={{
                margin: 'auto',
            }}
            top="0"
        >
            <OutclinicDashboardLoadingState size="large" />
        </Box>
    );
}

interface IOutclinicDashboardLoadingStateProps {
    size?: 'medium' | 'large';
}

export function OutclinicDashboardLoadingState({
    size = 'medium',
}: Readonly<IOutclinicDashboardLoadingStateProps>): JSX.Element {
    return (
        <Box
            bottom="0"
            display="flex"
            justifyContent="center"
            my={20}
        >
            <Loader size={size} />
        </Box>
    );
}
